import { cn } from "../../../../lib/utils";

/**
 * Styles for legacy class names still used in ViewPAF (Bootstrap rows, react-select).
 */
export const VIEW_PAF_ROOT_CLASS = cn(
  "bg-white p-2.5",
  "[&_.error]:!text-[#e41818]",
  "[&_.row-other]:ml-2.5 [&_.row-other]:mt-1.5",
  "[&_.custom-select__control]:w-3/4",
  "[&_.custom-width-select_.custom-select__control]:w-full",
  "[&_.custom-select__menu]:w-3/4",
  "[&_.selectWidth]:w-[95%]",
  "[&_.mt-2_input]:mb-4 [&_.mt-2_input]:mt-2.5 [&_.mt-2_input]:h-[30px] [&_.mt-2_input]:border-0 [&_.mt-2_input]:border-b [&_.mt-2_input]:border-[#c8c8c8] [&_.mt-2_input]:bg-[#f8f8f8] [&_.mt-2_input]:text-xl [&_.mt-2_input]:leading-[22px] [&_.mt-2_input]:!text-[#646464]",
  "[&_.display-flex-tooltip]:flex [&_.display-flex-tooltip]:flex-wrap [&_.display-flex-tooltip]:items-baseline [&_.display-flex-tooltip]:gap-x-2 [&_.display-flex-tooltip]:gap-y-1"
);

/** Field titles: weight 500 */
export const fieldLabel =
  "mb-1 text-[11px] font-medium uppercase tracking-wide text-[#8c8c8c]";

/** Header row in the dosage / supply card (titles: weight 500) */
export const dosageSupplyFieldLabel =
  "mb-1 text-[11px] font-medium uppercase tracking-wide text-[#1a1a1a]";

/** Information / values: weight 600 */
export const fieldValue =
  "text-[15px] font-semibold leading-snug text-[#3c3c3c]";

export const dosageEditLinkClass =
  "ml-2 inline-block cursor-pointer text-[11px] font-semibold uppercase tracking-wide text-[#0097a7] underline hover:text-[#007c8a]";

export const dosageSupplyCardClass = cn(
  "mt-4 mb-5 rounded-lg border border-[#dcdcdc] bg-[#fafafa] px-4 py-4 sm:px-5 sm:py-5",
  "[&_.font-size-16]:text-[15px] [&_.font-size-16]:font-semibold [&_.font-size-16]:text-[#3c3c3c]",
  "[&_.green-haze-color]:text-[15px] [&_.green-haze-color]:font-semibold"
);

/** Same typography as meta column headers; `block` for `<label>`. */
export const pafSectionLabelClass = cn(fieldLabel, "block");
